import {useSelector} from 'react-redux'
import {ShieldIcon, ArrowLeftIcon} from '../../../icons'
import CopyButton from '../../core/copyButton'
import OtpInput from '../../core/otpInput'
import Error from '../../core/error'
import {MFA_STEPS} from '../../../stores/security'
import {SimpleBlueButton} from '../../core/button'
import ButtonLoader from '../../core/button/ButtonLoader'
import {colors} from '../../../utils/colors'

const OTP_LENGTH = 6

const SetupView = ({text, qrData, otpCode, error, step, onVerify, onCancel, onChange, onKeyDown, onPaste, inputRefs}) => {
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    return (
        <div className='security-card'>
            <div className='mfa-setup'>
                <div className='mfa-setup-header'>
                    <button
                        type='button'
                        className='mfa-back-button'
                        onClick={onCancel}
                        aria-label={text.cancel}
                    >
                        <ArrowLeftIcon color={isDarkMode ? colors.colorFilterTitle : colors.colorMuted} />
                    </button>
                    <div className='security-icon security-icon--active'>
                        <ShieldIcon />
                    </div>
                    <h3 className='security-card-title'>{text.setup_title}</h3>
                </div>

                <div className='mfa-setup-body'>
                    <div className='mfa-qr-section'>
                        <div className='mfa-qr-container'>
                            <img
                                src={`https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(qrData.otpauthUri)}`}
                                alt='QR Code'
                                width='180'
                                height='180'
                            />
                        </div>
                    </div>

                    <div className='mfa-setup-instructions'>
                        <p className='mfa-setup-text'>{text.scan_qr}</p>

                        <div className='mfa-secret-section'>
                            <span className='mfa-secret-label'>{text.manual_entry}</span>
                            <div className='mfa-secret-row'>
                                <code className='mfa-secret-code'>{qrData.secret}</code>
                                <CopyButton className='security-btn security-btn--icon' text={qrData.secret} />
                            </div>
                        </div>

                        <div className='mfa-verify-section'>
                            <label className='mfa-verify-label'>{text.enter_code}</label>

                            <OtpInput
                                otpCode={otpCode}
                                onChange={onChange}
                                onKeyDown={onKeyDown}
                                onPaste={onPaste}
                                inputRefs={inputRefs}
                                disabled={step === MFA_STEPS.ENABLING}
                            />

                            {error && <Error error={error} />}

                            <div className='mfa-verify-actions'>
                                <SimpleBlueButton
                                    onClick={onVerify}
                                    disabled={step === MFA_STEPS.ENABLING || otpCode.join('').length !== OTP_LENGTH}
                                >
                                    {step === MFA_STEPS.ENABLING && <ButtonLoader />}
                                    {text.verify}
                                </SimpleBlueButton>

                                <SimpleBlueButton
                                    outline
                                    onClick={onCancel}
                                >
                                    {text.cancel}
                                </SimpleBlueButton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SetupView
